<template>
  <div style="width:100%;height:100%">
    <h1 class="chart-top-title">药品召回统计<span class="chart-modal-flag" @click="openModal"><i class="el-icon-view"></i></span></h1>
    <div
      class="chart-wrapper"
      ref="chart"
      style="height:364px;width:100%;margin-left:20px"
    >
    </div>
    <Cube></Cube>
    <el-dialog :visible.sync="dialogVisible" :append-to-body="true" :fullscreen="true" center :modal="mask">
      <img style="width: 100%; height: 100%;" src="../../../static/imgs/drugRecall.jpg" alt="">
    </el-dialog>
  </div>
</template>

<script>
import { vueBus } from '../../assets/js/common/vueBus'
import Cube from '../cube'
export default {
  name: 'pictorialBar',
  props: {
    echartsData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dialogVisible: false,
      mask: false,
      fullscreen: true,
      anima: '',
      color: ['#13D3F1', '#BEE061']
    }
  },
  watch: {
    echartsData: {
      handler: function(val, oldVal) {
        this.initChart()
      },
      deep: true //增加deep 观察对象的子对象变化
    },
    anima: {
      handler: function(val, oldVal) {
        if (val == 'animateStart') {
          this.myChart = this.$echarts.init(this.$refs.chart)
          this.initChart()
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      let me = this
      vueBus.$on('imgOnload', v => {
        me.anima = v
      })
    })
  },
  methods: {
    handleClose(done) {
      done();
    },
    initChart() {
      var myData = ['盐酸氨溴索注射液', '细菌溶解物', '甲氨喋呤注射液',  '批冻干人用狂犬病疫苗', '注射用重组人凝血因子Ⅷ']
      var dataFirm = {
        1: [
          { name: '', value: 1412347 },
          { name: '', value: 598765 },
          { name: '', value: 170000 },
          { name: '', value: 10902 },
          { name: '', value: 3106 }
        ]
      }
      // var dataFirmDot = dataFirm[1].map(item => {
      //   return item.value - 3000
      // })
      var dataFirmDot = [1350000, 550000, 120000, 0, 0]
      var dataFirmStack = {
        1: [141234, 141234, 141234, 141234, 141234]
      }
      var myData1 = ['触达数量', '触达数量', '触达数量', '触达数量', '触达数量']
      var dataDevice = {
        1: [
          { name: '', value: 1384100 },
          { name: '', value: 586789 },
          { name: '', value: 166600 },
          { name: '', value: 2526 },
          { name: '', value: 3044 }
        ]
      }
      // var dataDeviceDot = dataDevice[1].map(item => {
      //   return item.value - 3000
      // })
      var dataDeviceDot = [1300000,510000, 100000, 0, 0]
      var dataDeviceStack = {
        1: [158410, 158410, 158410, 158410, 158410]
      }
      var timeLineData = [1];
      var option = {
        baseOption: {
          timeline: {
            show: false,
            top: 0,
            data: []
          },
          legend: {
            show: false
          },
          tooltip: {
            show: true,
            trigger: 'axis',
            formatter: '{b}<br/>{a}: {c}人',
            axisPointer: {
              type: 'shadow'
            }
          },

          grid: [
            {
              show: false,
              left: '2%',
              top: 80,
              bottom: 50,
              right: 50,
              // containLabel: true,
              width: '38%'
            },
            {
              show: false,
              left: '52.5%',
              top: 80,
              bottom: 50,
              width: '0%'
            },
            {
              show: false,
              right: '9%',
              top: 80,
              bottom: 50,
              containLabel: true,
              width: '30%'
            }
          ],

          xAxis: [
            {
              type: 'value',
              inverse: true,
              axisLine: {
                show: false
              },
              axisTick: {
                show: false
              },
              position: 'top',
              axisLabel: {
                show: false
              },
              splitLine: {
                show: false
              }
            },
            {
              gridIndex: 1,
              show: false
            },
            {
              gridIndex: 2,
              nameTextStyle: {
                color: '#50afff',
                fontSize: 14
              },
              axisLine: {
                show: false
              },
              axisTick: {
                show: false
              },
              position: 'top',
              axisLabel: {
                show: false
              },
              splitLine: {
                show: false
              }
            }
          ],
          yAxis: [
            {
              type: 'category',
              inverse: true,
              offset: 0,
              boundaryGap: false,
              position: 'right',
              axisLine: {
                show: true,
                lineStyle: {
                  color: 'rgb(71, 165, 214)'
                }
              },
              axisTick: {
                show: true,
                inside: true,
                length: 23
              },
              axisLabel: {
                show: true,
                color: '#fff',
                inside: true,
                margin: 30,
                verticalAlign: 'bottom',
                padding: [0, 0, 15, 0]
              },
              data: myData
            },
            {
              gridIndex: 1,
              type: 'category',
              inverse: true,
              position: 'right',
              axisLine: {
                show: false,
                lineStyle: {
                  color: '#f00'
                }
              },
              axisTick: {
                show: false
              },
              axisLabel: {
                show: false,
                inside: true,
                margin: 0,

                verticalAlign: 'bottom',
                padding: [0, 0, 10, 0]
              },
              data: myData1
            },
            {
              gridIndex: 2,
              type: 'category',
              inverse: true,
              boundaryGap: false,
              position: 'left',
              axisLine: {
                show: true,
                lineStyle: {
                  color: 'rgb(71, 165, 214)'
                }
              },
              axisTick: {
                show: true,
                inside: true,
                length: 23
              },
              axisLabel: {
                show: true,
                color: '#fff',
                inside: true,
                margin: 30,
                verticalAlign: 'bottom',
                padding: [0, 0, 15, 0]
              },
              data: myData1
            }
          ],
          series: []
        },
        options: []
      }
      option.baseOption.timeline.data.push(timeLineData[0])
      option.options.push({
        tooltip: {
          show: false
        },
        series: [
          {
            name: '接入单位辅助',
            type: 'bar',
            stack: '接入单位',
            barWidth: 14,
            barMinWidth: 5,
            label: {
              normal: {
                show: false
              }
            },
            itemStyle: {
              normal: {
                color: 'transparent'
              }
            },
            z: -9,

            data: dataFirmStack[timeLineData[0]]
          },
          {
            name: '接入单位',
            type: 'bar',
            barWidth: 14,
            barMinWidth: 5,
            stack: '接入单位',
            label: {
              normal: {
                show: true,
                position: 'left',
                offset: [0, 0],
                textStyle: {
                  color: this.color[0],
                  fontSize: 14
                }
              }
            },
            itemStyle: {
              normal: {
                color: 'transparent',
                borderColor: this.color[0],
                borderWidth: 3,
                barBorderRadius: 50
              }
            },
            z: -11,
            data: dataFirm[timeLineData[0]]
          },
          {
            name: 'dotted',
            type: 'pictorialBar',
            symbol: 'rect',
            symbolPosition: 'start',
            symbolOffset: ['-30', 0],
            itemStyle: {
              normal: {
                color: this.color[0]
              }
            },
            symbolRepeat: true,
            symbolSize: [4, 8],
            symbolMargin: 1,
            z: -10,
            animationEasing: 'elasticOut',
            animationDelay: function(dataIndex, params) {
              return params.index * 50
            },
            data: dataFirmDot
          },
          {
            name: '接入设备辅助',
            type: 'bar',
            stack: '接入设备',
            xAxisIndex: 2,
            yAxisIndex: 2,
            label: {
              normal: {
                show: false
              }
            },
            itemStyle: {
              normal: {
                color: 'transparent'
              }
            },
            data: dataDeviceStack[timeLineData[0]]
          },
          {
            name: '接入设备',
            type: 'bar',
            stack: '接入设备',
            barWidth: 14,
            xAxisIndex: 2,
            yAxisIndex: 2,
            label: {
              normal: {
                show: true,
                position: 'right',
                offset: [0, 0],
                textStyle: {
                  color: this.color[1],
                  fontSize: 14
                }
              }
            },
            itemStyle: {
              normal: {
                color: 'transparent',
                barBorderRadius: 50,
                borderColor: this.color[1],
                borderWidth: 3
              }
            },
            data: dataDevice[timeLineData[0]]
          },
          {
            name: 'dotted',
            type: 'pictorialBar',
            xAxisIndex: 2,
            yAxisIndex: 2,
            symbol: 'rect',
            symbolPosition: 'start',
            symbolOffset: ['30', 0],
            itemStyle: {
              normal: {
                color: this.color[1]
              }
            },
            symbolRepeat: true,
            symbolSize: [4, 8],
            symbolMargin: 1,
            z: -10,
            animationEasing: 'elasticOut',
            animationDelay: function(dataIndex, params) {
              return params.index * 50
            },
            data: dataDeviceDot
          }
        ]
      })
      this.myChart.setOption(option)
      window.onresize = this.myChart.resize
    },
    openModal() {
      this.dialogVisible = true;
      
    },
  },
  components: {
    Cube
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.chart-modal-flag {
  line-height: 64px;
  font-size: 40px;
  font-weight: 700;
  color: #fff;
  right: 25px;
  position: absolute;
  i {
    color: #fff;
    cursor: pointer;
    font-weight: 900;
  }
}

.chart-top-title {
  height: 76px;
  line-height: 95px;
  font-size: 40px;
  font-weight: 700;
  color: #65ecc3;
  text-align: center;
  letter-spacing: 2px;
  position: relative;
  .chart-select {
    position: absolute;
    width: 175px;
    height: 45px;
    line-height: 45px;
    border: 2px solid #046292;
    left: 28px;
    top: 26px;
    border-radius: 8px;
    font-weight: 400;
    color: #fff;
    font-size: 20px;
    text-align: left;
    padding-left: 20px;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    -ms-border-radius: 8px;
    -o-border-radius: 8px;
  }
  .select-icon {
    position: absolute;
    font-size: 26px;
    right: 10px;
    top: 3px;
  }
 }
 .remarkes {
  height: 40px;
  line-height: 24px;
  font-size: 20px;
  color: #acb4bc;
  padding-left: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/echarts/pictorialBar.vue